import fetchHelpers from "../helpers/fetchHelpers";
import { apiUrl } from "../environmentConfig";

function apiCall(
  apiEndpoint,
  method = "",
  body = null,
  additionalHeaders = null,
  signal = null,
  autoParse = true
) {
  return new Promise((resolve, reject) => {
    const headers = {
      "content-type": "application/json",
      ...additionalHeaders,
    };

    const payload = fetchHelpers.buildPayload({
      method,
      body,
      signal,
      headers,
      credentials: "include",
    });

    fetch(`${apiUrl}${apiEndpoint}`, payload)
      .then(async (response) => {
        if (!response.ok) {
          if (response.status === 409) {
            const err = await response.json();
            throw new fetchHelpers.ApiErrors(response.status, err.message);
          }
          if (response.status === 401) {
            window.dispatchEvent(
              new CustomEvent("unauthorized", {
                detail: { status: response.status },
              })
            );
            throw new fetchHelpers.ApiErrors(401, "UNAUTHORIZED");
          }
          let message = response.statusText;
          try {
            const contentType = response.headers.get("content-type") || "";
            if (contentType.includes("application/json")) {
              const errBody = await response.json();
              message =
                errBody?.message ??
                errBody?.error ??
                errBody?.detail ??
                message;
            } else {
              const text = await response.text();
              if (text) {
                if (contentType.includes("text/html")) {
                  if (response.status === 405) {
                    message =
                      "Unable to remove tasks from sprint. Please restart the backend server.";
                  } else {
                    message = `Request failed (${response.status})`;
                  }
                } else {
                  message = text;
                }
              }
            }
          } catch (_) {}
          throw new fetchHelpers.ApiErrors(response.status, message);
        }

        return fetchHelpers.parseResponse(response, autoParse);
      })
      .then(resolve)
      .catch(reject);
  });
}

const fetchWrapper = { apiCall };

export default fetchWrapper;
